<template>
  <transition
    name="accordion"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave"
    @leave="onLeave"
  >
    <slot></slot>
  </transition>
</template>

<script setup>
// 1. Set the initial 0px state BEFORE the animation starts
const onBeforeEnter = (el) => {
  el.style.height = '0px';
  el.style.opacity = '0';
}

// 2. Animate to the full height DURING the enter phase
const onEnter = (el) => {
  el.offsetHeight; // Force the browser to register the 0px height first
  el.style.height = el.scrollHeight + 'px';
  el.style.opacity = '1';
}

// 3. Clean up AFTER it opens so it can resize responsively
const onAfterEnter = (el) => {
  el.style.height = 'auto';
  // Clean up inline opacity so CSS hover effects (if any) don't break
  el.style.opacity = ''; 
}

// 4. Lock in the current height BEFORE it starts closing
const onBeforeLeave = (el) => {
  el.style.height = el.scrollHeight + 'px';
}

// 5. Animate back down to 0px DURING the leave phase
const onLeave = (el) => {
  el.offsetHeight; // Force the browser to register the pixel height first
  el.style.height = '0px';
  el.style.opacity = '0';
}
</script>

<style scoped>
/* We only need the active classes now! The JS handles the from/to states. */
.accordion-enter-active,
.accordion-leave-active {
  transition: height 0.35s cubic-bezier(0.25, 1, 0.5, 1),
              opacity 0.35s cubic-bezier(0.25, 1, 0.5, 1);
  overflow: hidden;
}
</style>